

































import RichTextContainer from '@/components/rich-text-container/RichTextContainer.vue'
import { defineComponent, computed, ref, Ref } from '@vue/composition-api'

import { AnslAddressSearch, AnslGenericPageAlerts } from '@/components/common'

import {
  getAreaInfo,
  getLoading,
  getException,
  setSelectedAddress,
  clearException,
  fetchAreaInfo
} from '@/store/modules/area.store'

import { Address, Apartment } from '@/types/area-response.types'

import { resetFlowStore } from '@/store/modules/order-flow.store'
import { resetForm } from '@/store/form/form.store'
import { Actions as AddressSearchActions } from '@/store/modules/address-search.store'
import { Modal } from '@/types/common.types'

import { TcButton } from '@telia/shared-ui-components'
import AnslModal from '@/components/common/Modal.vue'

import { Entry } from 'contentful'
import { accessorFactory, Namespace } from '@/store'
import { CfAnslRedirectModal } from '@/types/ansl-space/types/cf-ansl-redirect-modal'
import { AreaType } from '@/constants/operator'
import { getRouteForArea } from '@/router/utils'

const {
  fetchContent: fetchRedirectModalContent,
  getLoading: getRedirectModalLoading,
  getException: getRedirectModalException,
  getContent: getRedirectModalContent
} = accessorFactory<Entry<CfAnslRedirectModal>>(Namespace.RedirectModalContent)

export default defineComponent({
  components: {
    AnslModal,
    AnslAddressSearch,
    AnslGenericPageAlerts,
    TcButton,
    RichTextContainer
  },
  setup (_, context) {
    const store = context.root.$store
    const redirectModalRef: Ref<Modal> = ref({} as Modal)

    clearException(store)

    const loadingContent = computed(() => getRedirectModalLoading(store))
    const loading = computed(() => getLoading(store))
    const exception =
      computed(() => getException(store)) || getRedirectModalException(store)
    const areaInfo = computed(() => getAreaInfo(store))

    const redirectModalContent = computed(() => getRedirectModalContent(store))
    const showRedirectModal = computed(
      () => areaInfo.value?.AreaTypeName === AreaType.MassMarket
    )

    const handleAddressSelection = async (payload: Address & Apartment) => {
      setSelectedAddress(store, payload)
      await resetFlowStore(store)
      await resetForm(store, 'orderDetails')
      await fetchAreaInfo(store, payload)

      if (showRedirectModal.value) {
        redirectModalRef.value.showModal()
        await fetchRedirectModalContent(store)
        return
      }

      await AddressSearchActions.clearAddresses(store)

      const nextRoute = getRouteForArea(areaInfo.value)

      if (nextRoute) {
        await context.root.$router.push({ name: nextRoute })
      } else {
        window.location.assign(payload.RedirectUrl)
      }
    }

    const redirectToTeliaSe = () => {
      if (redirectModalContent.value?.fields?.redirectButton?.fields?.link) {
        window.location.replace(redirectModalContent.value.fields.redirectButton.fields.link)
      }
    }

    return {
      redirectModalContent,
      redirectModalRef,
      redirectToTeliaSe,
      loadingContent,

      handleAddressSelection,
      loading,
      exception
    }
  }
})
